export default "static/media/jamhacks.dcfc453.svg"